import { useNavigate } from 'react-router-dom';
import SignInFormContainer from '../../features/auth/components/sign-in/sign-in-form.container';
import { Box, Button, Typography } from '@mui/material';
import RegistrationLogo from '../../components/icons/logo/full-text-logo';
import usePageViews from '../../hooks/ga4/usePageViews';
import ErrorSnackContainer from '../../components/feedback/errors/error-snack.container';
import Link from '../../components/navigation/Link';
import { useUserStore } from '@oai-frontend-monorepo/state-management';
import { useEffect } from 'react';
import { parseToken } from '@oai-frontend-monorepo/utils';
import logEvent from '../../hooks/ga4/logEvent';

const SignInPage = () => {
  usePageViews();
  const nav = useNavigate();

  const handleSuccess = () => {
    nav('/dashboard');
  };

  useEffect(() => {
    const token = useUserStore.getState().token;

    if (token) {
      const parsed = parseToken(token);

      if (parsed && parsed.exp > Date.now() / 1000) {
        nav('/dashboard');
      }
    }
  }, [nav]);

  const handleSignUp = () => {
    nav('/sign-up');

    logEvent({
      action: 'sign-up-button',
      category: 'click',
      label: 'registration',
    });
  };

  return (
    <div data-testid="page--sign-in">
      <Box p={3} maxWidth="sm">
        <RegistrationLogo />

        <Typography mt={10} mb={5} variant="h2" fontWeight="900">
          Sign In
        </Typography>

        <SignInFormContainer onSuccess={handleSuccess} />

        <Box maxWidth={200} margin="0 auto">
          <Link to="/forgot-password">
            <Typography textAlign="center" mt={4} mb={4}>
              Forgot your password?
            </Typography>
          </Link>

          <Typography textAlign="center" mt={8} mb={4}>
            Don't have an account?
          </Typography>

          <Button
            size="large"
            fullWidth
            onClick={handleSignUp}
            variant="contained"
            color="secondary"
          >
            Sign Up
          </Button>
        </Box>
      </Box>

      <ErrorSnackContainer />
    </div>
  );
};

export default SignInPage;
